module.exports = __webpack_public_path__ + "static/media/headphone-icon.7110a6f4.webp";